import { buildEndpointUrl } from '@/_shared/helpers/makeSwaggerToEndpointUrl';
import {
  API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_COLORS_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_DESIGN_LINK_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_DESIGN_PATH_KEY,
} from '@/swagger/constants/slash-keys';

export const API_GET_ASPECT_CALL = (org: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_DESIGN_PATH_KEY, {
    organizationId: org,
  });
};

export const API_GET_ASPECT_COLORS_CALL = (org: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_COLORS_PATH_KEY, {
    organizationId: org,
  });
};

export const API_POST_ASPECT_CALL = (org: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_DESIGN_LINK_PATH_KEY, {
    organizationId: org,
  });
};

export const API_POST_ASPECT_CREATE_CALL = (org: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_DESIGN_PATH_KEY, {
    organizationId: org,
  });
};

export const API_PUT_ASPECT_CALL = (org: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_DESIGN_PATH_KEY, {
    organizationId: org,
  });
};
